import { msg } from '@lingui/core/macro';
import type { MessageDescriptor } from 'shared/i18n';

/** Matches `Tournament::DEFAULT_TIMEZONE` on the backend. */
export const DEFAULT_ORGANIZER_TIMEZONE = 'Asia/Novosibirsk';

export const ORGANIZER_TIMEZONE_OPTIONS: readonly { value: string; label: MessageDescriptor }[] = [
  { value: 'Asia/Novosibirsk', label: msg`Новосибирск (UTC+7)` },
  { value: 'Asia/Yekaterinburg', label: msg`Екатеринбург (UTC+5)` },
  { value: 'Europe/Moscow', label: msg`Москва (UTC+3)` },
  { value: 'Europe/Kaliningrad', label: msg`Калининград (UTC+2)` },
  { value: 'UTC', label: msg`UTC` },
];
